import { Component } from '@angular/core';

/**
 * Generated class for the FoodIconComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'food-icon',
  templateUrl: 'food-icon.html'
})
export class FoodIconComponent {
  constructor() {
  }
}



// WEBPACK FOOTER //
// ./src/components/icons/food-icon/food-icon.ts